/**
 * Keys purged from `localStorage` whenever the auth state is reset. The only
 * caller is `Auth.reset()` (stores/Auth.ts), which runs this and then
 * dispatches the `tmi:auth-reset` event so user-scoped stores drop their
 * in-memory copies. The router's auth guard does NOT purge (tmi-6gh, LD1;
 * pinned by auth-guard.spec.ts).
 *
 * This list used to be seven inline `localStorage.removeItem` calls with
 * zero test coverage (R7). Pulling it out gives the purge behavior a spec
 * home and makes adding a new user-scoped key (e.g. `sss-filters`) a single
 * line instead of a silent gap.
 */
export const USER_SCOPED_PURGE_KEYS = [
    "fav_art",
    "fav_sec",
    "fav_web",
    "model-portfolios",
    "my-portfolios",
    "permissions",
    "user",
    "sss-filters",
] as const

export function purgeUserScopedStorage(): void {
    for (const key of USER_SCOPED_PURGE_KEYS) {
        localStorage.removeItem(key)
    }
}
